import React from "react";

const StoreSummaryHeader = ({ visibleStart, visibleEnd, filteredStores, counts, filter, selectedStore, t }) => (
  <div className="subheader">
    {t('showing')} <strong>{visibleStart}</strong>–<strong>{visibleEnd}</strong> {t('of')} <strong>{filteredStores.length}</strong> {filter === "All" ? t('stores') : `${filter.toLowerCase()} ${t('stores')}`}
    {selectedStore.length > 0 && <> (filtered from {counts.all} {t('total')})</>}
  </div>
);

export default StoreSummaryHeader;